const Util = require('./../Util').default;

let CustomerAddress = new function () {

};

CustomerAddress.init = function () {
    this._bindEvents();
};

CustomerAddress._bindEvents = function () {
    let self = CustomerAddress;

    $('.country-choice :radio').on('change', function (e) {
        let container = $(this).closest('.address-container');
        let address_container = container;

        if ($(container).attr('data-address-container')) {
            address_container = $('#' + $(container).attr('data-address-container'));
        }

        let value = $('.country-choice :checked', $(container)).val();

        if (value && $(this).is(':checked')) {
            self._triggerCountryAddressElement(address_container, value);

            if (value !== 'other') {
                $('.country .country-list-other', $(container)).val(value);
                $('.country .country-list', $(container)).val(value);
            }
        }
    });

    // Call only change event on selected input on page load.
    $('.country-choice :radio:checked').trigger('change')

    if ($('.country-choice').length === 0) {
        $('.country select', '.address-container').on('change', function (e) {
            let container = $(this).closest('.address-container');

            if ($(container).attr('data-address-container')) {
                container = $('#' + $(container).attr('data-address-container'));
            }

            let value = $('.country select', $(container)).val();

            self._triggerCountryAddressElement(container, value);
        }).trigger('change');
    }

    $('.country .country-list-other').on('change', function (e) {
        const elm = $(this);
        const value = elm.val();
        const rowCountryInputs = elm.closest('.row-country-inputs');
        const countryList = rowCountryInputs.find('.country select.country-list');

        if (countryList.length > 0) {
            countryList.val(value);
        } else {
            let container = $(this).closest('.address-container');
            if ($(container).attr('data-address-container')) {
                container = $('#' + $(container).attr('data-address-container'));
            }
            $('.country .country-list', $(container)).val(value);
        }
    });

    const newsletter = document.querySelector('#customer_newsletter')
    if (newsletter && newsletter.classList.contains('hidden')) {
        newsletter.closest('.form-group').classList.add('hidden')
    }


    let searchAddressDelay = null;
    let searchAddressDelayTime = 0;

    $('.postcode input, .number input, .number-addition', '.address-container').on('change', function (e) {

        let container = $(this).closest('.address-container');
        let country = CustomerAddress.getCountryFromContainer(container);

        if (country && country.toLowerCase() !== 'nl') {
            return;
        }

        const postcode = $('.postcode input', $(container)).val();
        const number = $('.number input', $(container)).val();
        const numberAddition = $('.number-addition input', $(container)).val();

        if (!e.isTrigger) {
            $('.street input', $(container)).val('');
            $('.city input', $(container)).val('');
        }

        $('.number-addition input', $(container)).closest('.form-group').removeClass('has-danger');

        $('#number-addition-select-input').parent().remove();
        $('.number-addition input', $(container)).show();

        searchAddressDelayTime = 0;

        if (e.type === 'keyup') {
            searchAddressDelayTime = 2000;
        }

        clearTimeout(searchAddressDelay);

        container.attr('data-address-searching', 1);

        searchAddressDelay = setTimeout(function () {
            clearTimeout(searchAddressDelay);

            Util.checkPostcodeAndNumber(postcode, number, numberAddition, country, container, self.processPostcodeAndNumber);
        }, searchAddressDelayTime);
    }).trigger('change');

    $('.postcode input', '.address-container').on('keyup', function (e) {
        let value = $(this).val();

        let start = $(this).get(0).selectionStart,
            end = $(this).get(0).selectionEnd;

        value = value.toString().toUpperCase()
        .replace(/\s+/g, '')                   // Replace spaces with -
        .replace(/&/g, '')                  // Replace & with 'and'
        .replace(/[^\w\-]+/g, '')                   // Remove all non-word chars
        .replace(/\-\-+/g, '')                 // Replace multiple - with single -
        .trim();

        $(this).val(value);

        $(this).get(0).setSelectionRange(start, end);
    });

    /* be postcode validation */
    $('.postcode input, .city input', '.address-container').on('change', function (e) {

        let container = $(this).closest('.address-container');
        let country = CustomerAddress.getCountryFromContainer(container);

        if (!country || country.toLowerCase() !== 'be') {
            return;
        }

        if (!$('.postcode input', $(container)).is(':visible')) {
            return; // skip validation if postcode field isn't visible
        }

        const postcode = $('.postcode input', $(container)).val();
        const city = $('.city input', $(container)).val();

        Util.checkBECityAndPostcode(city, postcode, container, self.processBECityAndPostcodeCheck);
    }).trigger('change');
};

CustomerAddress.getCountryFromContainer = function (container) {

    let country_container = container;
    let country;

    if ($(container).attr('data-country-container')) {
        country_container = $('#' + $(container).attr('data-country-container'));
    }

    if ($('.country-choice').length === 0) {
        country = $('.country select', $(country_container)).val();
    } else {
        let countryRadioActive = $('.country-choice', $(country_container)).find('.radio').length;

        if (countryRadioActive) {
            country = $('.country-choice', $(country_container)).find(':checked').val();
        } else {
            country = $('.country-choice', $(country_container)).val();
        }
    }

    return country;
}

CustomerAddress.processBECityAndPostcodeCheck = function (result, container) {

    const cityElement = $('.city input', $(container));

    if (!result || result.length === 0) {
        return;
    }

    for (const suggestion of result.items) {
        if (cityElement.val().trim().toLowerCase() === suggestion.substr(5).toLowerCase()) {
            return; // fields are filled correctly. No action required.
        }
    }

    // No results. Show basic alert without suggestions.
    if(result.items.length === 0) {
        swal({
            title: trans('label.postcode.be.unknown'),
            html: trans('label.postcode.be.no-results').replace(/\n/g, "<br>"),
            type: "warning",
        }).then(
          function () {
              cityElement.parent('.form-group').addClass('has-error');
              setTimeout(function (){
                  cityElement.parent('.form-group').removeClass('has-error')
              }, 3000);
          }
        );

        return;
    }

    // Exactly 1 result. Show alert to accept or reject the suggestion.
    if(result.items.length === 1) {
        swal({
            title: trans('label.postcode.be.unknown'),
            text: trans('label.postcode.be.single-suggestion').replace('%city%', '"' + result.items[0].substr(5) + '"'),
            type: 'question',
            showCancelButton: true,
            confirmButtonColor: '#4CAF50',
            confirmButtonText: 'Ja',
            cancelButtonText: 'Nee',
            confirmButtonClass: 'btn-success',
            allowEscapeKey: false,
        }).then(
          function (isConfirm) {
              if(isConfirm.value) {
                  cityElement.val(result.items[0].substr(5));
              }
          }
        );

        return;
    }

    // 2 or more results. Show dropdown with possible cities.
    let cityList = { };
    for (let suggestion of result.items) {
        cityList[suggestion.substr(5)] = suggestion.substr(5)
    }

    swal({
        title: trans('label.postcode.be.unknown'),
        html: trans('label.postcode.be.multi-options'),
        input: 'select',
        inputOptions: cityList,
        type: "warning",
        showCancelButton: true,
        customClass: 'postcode-dropdown'
    }).then(
      function (isConfirm) {
          if(isConfirm.value) {
              cityElement.val(isConfirm.value);
          }
      }
    );
};

CustomerAddress.createNumberAdditionList = function (
  numberAdditionOptions, houseNumberAdditionsLength, result, currentNumberAddition,
) {
    for (let i = 0; i < houseNumberAdditionsLength; i++) {
        const addition = result.houseNumberAdditions[i];
        const isCurrent = currentNumberAddition === null ? '' : currentNumberAddition.toLowerCase();
        const selectCurrent = addition.toLowerCase() === isCurrent ? ' selected="selected"' : '';
        numberAdditionOptions.push(
            `<option value="${addition}" ${selectCurrent}>${addition ? addition : '&nbsp;'}</option>`
        );
    }
};

CustomerAddress.processPostcodeAndNumber = function (result, container) {
    const postcodeElement = $('.postcode input', $(container));
    const numberElement = $('.number input', $(container));
    const numberAdditionElement = $('.number-addition input', $(container));
    const streetElement = $('.street input', $(container));
    const cityElement = $('.city input', $(container));

    $(container).attr('data-address-searching', 0);
    $(container).attr('data-address-found', 0);

    if (!result || result.length === 0) {
        $('.row-street-and-city input', $(container));
        $('.row-street-and-city .street input', $(container)).focus();

        return;
    }

    const currentNumberAddition = numberAdditionElement.val();
    const houseNumberAdditionsLength = result.houseNumberAdditions.length;

    postcodeElement.val(result.postcode).addClass('filled');
    numberElement.val(result.houseNumber).addClass('filled');

    streetElement.val(result.street).addClass('filled').trigger('change');
    cityElement.val(result.city).addClass('filled').trigger('change');

    if (currentNumberAddition && result.houseNumberAddition) {
        numberAdditionElement.val(result.houseNumberAddition).addClass('filled');
    }

    if (houseNumberAdditionsLength > 1 || (houseNumberAdditionsLength === 1 && result.houseNumberAdditions[0].length > 0)) {
        let numberAdditionOptions = [];

        CustomerAddress.createNumberAdditionList(
            numberAdditionOptions, houseNumberAdditionsLength, result, currentNumberAddition
        );

        const numberAdditionSelect = $('<div id="number-addition-select" class="form-select-wrapper"><select name="number-addition-select" id="number-addition-select-input" class="form-control">' + numberAdditionOptions.join('') + '</select></div>');

        numberAdditionElement.hide();
        numberAdditionSelect.insertBefore(numberAdditionElement);
        numberAdditionElement.val($('#number-addition-select-input').val());

        $('#number-addition-select-input').on('change', function (e) {
            numberAdditionElement.val($(this).val());
        });
    }

    $(container)
        .attr('data-address-found', 1)
        .attr('data-address-searched-postcode', result.postcode)
        .attr('data-address-searched-houseNumber', result.houseNumber)
        .attr('data-address-searched-street', result.street)
        .attr('data-address-searched-city', result.city)
    ;
};

CustomerAddress._triggerCountryAddressElement = function (container, choice) {
    let country_container = container;

    if ($(container).attr('data-country-container')) {
        country_container = $('#' + $(container).attr('data-country-container'));
    }

    switch (choice.toLowerCase()) {
        case 'nl':
            $('.row-postcode-and-city', $(container)).hide();
            $('.row-country .country .country-list-other', $(country_container)).hide();
            $('.row-country .country', $(country_container)).hide();
            break;
        case 'be':
            $('.row-postcode-and-city', $(container)).show();
            $('.row-country .country', $(country_container)).hide();
            break;
        case 'other':
            $('.row-postcode-and-city', $(container)).hide();
            $('.row-country .country .country-list-other', $(country_container)).show();
            $('.row-country .country', $(country_container)).show();
            break;
    }
};

CustomerAddress._movePostcodeToCity = function (container) {
    let postcode = $('.row .postcode', $(container)).clone(true);

    $('.row .postcode:first', $(container)).remove();

    $(postcode).insertBefore($('.city', $(container)));
};

CustomerAddress._movePostcodeToNumber = function (container) {
    let postcode = $('.row .postcode', $(container)).clone(true);

    $('.row .postcode:first', $(container)).remove();

    $(postcode).insertBefore($('.street', $(container)));
};

CustomerAddress._moveStreetToPostcode = function (container) {
    let street = $('.row .street', $(container)).clone(true);

    $('.row .street:first', $(container)).remove();

    $(street).insertBefore($('.number', $(container)));

    $('.city, .street', $(container)).removeClass('col-md-6').addClass('col-md-8');
    $('.street', $(container)).hide();

    $('.city', $(container)).closest('.col-md-12').removeClass('col-md-12').addClass('col-md-8');
    $('.city', $(container)).hide();
};

CustomerAddress._moveStreetToCity = function (container, invoice) {
    let street = $('.street', $(container)).clone(true);

    $('.street:first', $(container)).remove();

    if (invoice) {
        $(street).appendTo($('.row-invoice-street', $(container)));

        $('.city, .street', $(container)).removeClass('col-md-8').addClass('col-md-12').show();
        $('.city, .street', $(container)).show();
        $('.row-invoice-city, .row-invoice-street', $(container)).show();
    } else {
        $(street).insertBefore($('.city', $(container)));

        $('.city, .street', $(container)).removeClass('col-md-8').addClass('col-md-6').show();
        $('.city', $(container)).closest('.col-md-8').removeClass('col-md-8').addClass('col-md-12');
    }
};

module.exports = CustomerAddress;
